function withOpacityValue(variable) {
    return ({ opacityValue }) => {
        if (opacityValue === undefined) {
            return `rgb(var(${variable}))`
        }
        return `rgba(var(${variable}), ${opacityValue})`
    }
}

module.exports = {
    black: withOpacityValue('--black'),
    white: withOpacityValue('--white'),
    shade: {
        0: withOpacityValue('--shade-0'),
        100: withOpacityValue('--shade-100'),
        'opacity-100': 'rgba(var(--shade-opacity-100))',
        200: withOpacityValue('--shade-200'),
        'opacity-200': 'rgba(var(--shade-opacity-200))',
        300: withOpacityValue('--shade-300'),
        'opacity-300': 'rgba(var(--shade-opacity-300))',
        600: withOpacityValue('--shade-600'),
        700: withOpacityValue('--shade-700'),
        900: withOpacityValue('--shade-900'),
    },
    accent: {
        'opacity-100': 'rgba(var(--accent-opacity-100))',
        100: withOpacityValue('--accent-100'),
        'opacity-200': 'rgba(var(--accent-opacity-200))',
        200: withOpacityValue('--accent-200'),
        'opacity-300': 'rgba(var(--accent-opacity-300))',
        300: withOpacityValue('--accent-300'),
        600: withOpacityValue('--accent-600'),
        700: withOpacityValue('--accent-700'),
    },
    info: {
        100: withOpacityValue('--info-100'),
        600: withOpacityValue('--info-600'),
        700: withOpacityValue('--info-700'),
    },
    error: {
        100: withOpacityValue('--error-100'),
        600: withOpacityValue('--error-600'),
        700: withOpacityValue('--error-700'),
    },
    warning: {
        100: withOpacityValue('--warning-100'),
        600: withOpacityValue('--warning-600'),
        700: withOpacityValue('--warning-700'),
    },
    success: {
        100: withOpacityValue('--success-100'),
        600: withOpacityValue('--success-600'),
        700: withOpacityValue('--success-700'),
    },
    'deco-one': {
        100: withOpacityValue('--deco-one-100'),
        600: withOpacityValue('--deco-one-600'),
        700: withOpacityValue('--deco-one-700'),
    },
    'deco-two': {
        100: withOpacityValue('--deco-two-100'),
        600: withOpacityValue('--deco-two-600'),
        700: withOpacityValue('--deco-two-700'),
    },
    text: {
        default: withOpacityValue('--default-text'),
        primary: withOpacityValue('--primary-text'),
        secondary: withOpacityValue('--secondary-text'),
        tertiary: withOpacityValue('--tertiary-text'),
        interactive: withOpacityValue('--interactive-text'),
        disabled: withOpacityValue('--disabled-text'),
        valid: withOpacityValue('--valid-text'),
        invalid: withOpacityValue('--invalid-text'),
    },
    border: {
        default: 'var(--default-border-color)',
        strong: 'var(--strong-border-color)',
        subtle: 'var(--subtle-border-color)',
        accent: withOpacityValue('--accent-border-color'),
    },
}
